<template>
  <div class="itinerary-page" id="itineraryPage">

    <!-- Breadcrum NAV -->
    <div class="d-flex align-start sh-nav" v-if="settings.customFlight">
      <div class="sh-selected d-flex" @click="backLegSelect('leg1')">
        <img :src="leg1Selected.flight[0].logo" />
        <span class="sh-airline">{{ leg1Selected.flightName }}</span>
        <span class="sh-airport">
          {{ leg1Selected.flight[0].origin.AirportCode }}
          <i class="fas fa-plane"></i>
          {{ leg1Selected.flight[leg1Selected.flight.length - 1].destination.AirportCode }}
        </span>
      </div>
      <i class="fas fa-chevron-right"></i>
      <div class="sh-selected d-flex" @click="backLegSelect('leg2')" v-if="isReturning">
        <img :src="leg2Selected.flight[0].logo" />
        <span class="sh-airline">{{ leg2Selected.flightName }}</span>
        <span class="sh-airport">
          {{ leg2Selected.flight[0].origin.AirportCode }}
          <i class="fas fa-plane"></i>
          {{ leg2Selected.flight[leg2Selected.flight.length - 1].destination.AirportCode }}
        </span>
      </div>
      <i class="fas fa-chevron-right" v-if="isReturning"></i>
      <div class="default-txt review-trip active">Review trip</div>
    </div>

    <a class="back-to-home" @click="backLegSelect('leg1')" v-else>
      <i class="fas fa-angle-double-left"></i>
      Back to Flight List
    </a>

    <!-- Page Title -->
    <div class="it-page-header">Your itinerary</div>

    <div class="d-flex it-page-body align-start">
      <div class="it-body-details">

        <!-- Label: Better Price -->
        <!-- <div class="expected-box d-flex align-start">
          <i class="fas fa-arrow-down"></i>
          <div>
            <b>$1,746.71 is better than expected</b>
            <i class="fas fa-info-circle fa-fw"></i>
            <div class="eb-desc">The price is at least 21% lower than the typical fare found on Expedia</div>
          </div>
        </div> -->

        <!-- Flight Details -->
        <div class="flight-details-box it-page-box">
          <div class="fd-header" v-if="isReturning">
            <i class="fas fa-plane"></i>
            <span>Roundtrip</span>
          </div>

          <flight-details-box :legSelected="leg1Selected" leg="leg1"></flight-details-box>
          <div class="fd-trigger" @click="showFlightDetails('leg1')" v-if="leg1Selected.flight.length > 1">Flight Details</div>
          
          <hr class="fd-hr" v-if="isReturning"/>
          
          <flight-details-box :legSelected="leg2Selected" leg="leg2" v-if="isReturning"></flight-details-box>
          <div class="fd-trigger" @click="showFlightDetails('leg2')"
            v-if="isReturning && (leg2Selected.returnFlight.length > 1 || (settings.customFlight && leg2Selected.flight.length > 1))">
            Flight Details
          </div>
        </div>

        <!-- Cabin Details -->
        <!-- <div class="cabin-details" v-if="false">
          <div class="cd-title" v-if="isReturning">
            Your trip combines 2 one-way flights with 
            <span v-if="isSameAirline">same</span><span v-else>different</span> 
            airlines
          </div>
          <div class="cd-sub">
            <span v-if="isReturning">Each</span>
            <span v-else>Your</span>
            flight is subject to its own rules, restrictions and fees. Changes or cancellations apply to each ticket individually.
          </div>
          <div class="d-flex justify-space-between cd-box-container">
            <cabin-details-box :legSelected="leg1Selected" leg="leg1"></cabin-details-box>
            <cabin-details-box :legSelected="leg1Selected" leg="leg2" v-if="isReturning"></cabin-details-box>
          </div>
        </div> -->

        <!-- Ground Transpo -->
        <div class="ground-trans-box" v-if="booking.includedLandTranspo.length">
          <div class="gt-header">We pick a ride for you</div>

          <div class="gt-box it-page-box" v-if="!hideGround.pickup || !hideGround.dropoff">
            <div :class="['d-flex justify-space-between gt-ride', {'skip-ride':booking.includedLandTranspo.indexOf(0) === -1}]" v-if="!hideGround.pickup">
              <div class="gt-details">
                <div class="gt-r-header">Ground Transportation (Leg 1)</div>
                <div class="gt-r-service d-flex align-center">
                  <i class="fas fa-car-side"></i>
                  <div class="gt-r-status">Upcoming</div>
                  <span>{{ cabinLabel(findById('leg1', 'pickup').name) }}</span>
                </div>
                <div class="gt-r-locations d-flex align-start">
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground1PU}]">
                    <span class="gt-r-loc-val" @click="wrap.ground1PU = !wrap.ground1PU">{{ locations.pickup.title }}</span>
                    <div class="gt-r-value">
                      <span>Pickup Time:</span>
                      {{ dateFormat(locations.pickupDetails.pickupTime.leg1, true) }}
                      &middot;
                      {{ timeFormat(locations.pickupDetails.pickupTime.leg1, true) }}
                    </div>
                  </div>
                  <i class="fas fa-car-side"></i>
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground1DO}]">
                    <span class="gt-r-loc-val" @click="wrap.ground1DO = !wrap.ground1DO">{{ locations.pickupAirport.name }} ({{locations.pickupAirport.code}})</span>
                    <div class="gt-r-value">
                      <span>Dropoff Time:</span>
                      {{ dateFormat(locations.pickupDetails.pickupTime.leg1, true, landQuote.leg1Depart.eta) }}
                      &middot;
                      {{ timeFormat(locations.pickupDetails.pickupTime.leg1, true, landQuote.leg1Depart.eta) }}
                    </div>
                  </div>
                </div>
                <label class="gt-skip">
                  <img src="../../assets/img/car-transport.svg" />
                  <input type="checkbox" v-model="ground0" @click="toggleGround(0)" />
                </label>
              </div>
              <div class="gt-action" @click="changeRide('leg1', 'pickup')">
                <span v-if="leg1Free" class="free-label">FREE</span>
                <div v-else>
                  <span v-if="leg1Discount.value > 0" class="free-label">{{ `${dcLabel(leg1Discount)} OFF` }}</span>

                  <div v-show="false">{{ findById('leg1', 'pickup') }}</div>
                  <div v-if="leg1Discount.value > 0" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg1', 'pickup'), false), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg1', 'pickup'), false))}}</span>
                  </div>
                  <div v-else-if="findById('leg1', 'pickup').price != findById('leg1', 'pickup').origPrice" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg1', 'pickup'), false, 'origPrice'), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg1', 'pickup'), false, 'origPrice'))}}</span>
                  </div>

                  <span v-if="currency.code === 'USD'" class="ground-price">{{priceFormat(fullPrice(findById('leg1', 'pickup'), 'Leg1'), true)}}</span>
                  <span v-else class="ground-price">{{applyCurrency(fullPrice(findById('leg1', 'pickup'), 'Leg1'))}}</span>
                </div>

                <img :src="findById('leg1', 'pickup').img" />
                <div class="gt-capacity d-flex justify-center">
                  <div>
                    <i class="far fa-user"></i>
                    {{ findById('leg1', 'pickup').maxPax }}
                  </div>
                  <div>
                    <i class="fas fa-suitcase"></i>
                    {{ findById('leg1', 'pickup').maxLuggage }}
                  </div>
                </div>
                <a>Change ride</a>
              </div>
            </div>

            <hr v-if="!hideGround.pickup && !hideGround.dropoff" />

            <div :class="['d-flex justify-space-between gt-ride', {'skip-ride':booking.includedLandTranspo.indexOf(1) === -1}]" v-if="!hideGround.dropoff">
              <div class="gt-details">
                <div class="gt-r-service d-flex align-center">
                  <i class="fas fa-car-side"></i>
                  <div class="gt-r-status">Upcoming</div>
                  <span>{{ cabinLabel(findById('leg1', 'dropoff').name) }}</span>
                </div>
                <div class="gt-r-locations d-flex align-start">
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground2PU}]">
                    <span class="gt-r-loc-val" @click="wrap.ground2PU = !wrap.ground2PU">{{ locations.dropoffAirport.name }} ({{locations.dropoffAirport.code}})</span>
                    <div class="gt-r-value">
                      <span>Pickup Time:</span>
                      {{ dateFormat(locations.dropoffDetails.pickupTime.leg1, true) }}
                      &middot;
                      {{ timeFormat(locations.dropoffDetails.pickupTime.leg1, true) }}
                    </div>
                  </div>
                  <i class="fas fa-car-side"></i>
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground2DO}]">
                    <span class="gt-r-loc-val" @click="wrap.ground2DO = !wrap.ground2DO">{{ locations.dropoff.title }}</span>
                    <div class="gt-r-value">
                      <span>Dropoff Time:</span>
                      {{ dateFormat(locations.dropoffDetails.pickupTime.leg1, true, landQuote.leg1Arrive.eta) }}
                      &middot;
                      {{ timeFormat(locations.dropoffDetails.pickupTime.leg1, true, landQuote.leg1Arrive.eta) }}
                    </div>
                  </div>
                </div>
                <label class="gt-skip">
                  <img src="../../assets/img/car-transport.svg" />
                  <input type="checkbox" v-model="ground1" @click="toggleGround(1)" />
                </label>
              </div>
              <div class="gt-action" @click="changeRide('leg1', 'dropoff')">
                <span v-if="leg2Free" class="free-label">FREE</span>
                <div v-else>
                  <span v-if="leg2Discount.value > 0" class="free-label">{{ `${dcLabel(leg2Discount)} OFF` }}</span>

                  <div v-if="leg2Discount.value > 0" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg1', 'dropoff'), false), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg1', 'dropoff'), false))}}</span>
                  </div>
                  <div v-else-if="findById('leg1', 'dropoff').price != findById('leg1', 'dropoff').origPrice" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg1', 'dropoff'), false, 'origPrice'), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg1', 'dropoff'), false, 'origPrice'))}}</span>
                  </div>

                  <span v-if="currency.code === 'USD'" class="ground-price">{{priceFormat(fullPrice(findById('leg1', 'dropoff'), 'Leg2'), true)}}</span>
                  <span v-else class="ground-price">{{applyCurrency(fullPrice(findById('leg1', 'dropoff'), 'Leg2'))}}</span>
                </div>

                <img :src="findById('leg1', 'dropoff').img" />
                <div class="gt-capacity d-flex justify-center">
                  <div>
                    <i class="far fa-user"></i>
                    {{ findById('leg1', 'dropoff').maxPax }}
                  </div>
                  <div>
                    <i class="fas fa-suitcase"></i>
                    {{ findById('leg1', 'dropoff').maxLuggage }}
                  </div>
                </div>
                <a>Change ride</a>
              </div>
            </div>
          </div>

          <div class="gt-box it-page-box" v-if="isReturning && (!hideGround.pickup || !hideGround.dropoff)">
            <div :class="['d-flex justify-space-between gt-ride', {'skip-ride':booking.includedLandTranspo.indexOf(2) === -1}]" v-if="!hideGround.dropoff">
              <div class="gt-details">
                <div class="gt-r-header">Ground Transportation (Leg 2)</div>
                <div class="gt-r-service d-flex align-center">
                  <i class="fas fa-car-side"></i>
                  <div class="gt-r-status">Upcoming</div>
                  <span>{{ cabinLabel(findById('leg2', 'pickup').name) }}</span>
                </div>
                <div class="gt-r-locations d-flex align-start">
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground3PU}]">
                    <span class="gt-r-loc-val" @click="wrap.ground3PU = !wrap.ground3PU">{{ locations.dropoff.title }}</span>
                    <div class="gt-r-value">
                      <span>Pickup Time:</span>
                      {{ dateFormat(locations.pickupDetails.pickupTime.leg2, true) }}
                      &middot;
                      {{ timeFormat(locations.pickupDetails.pickupTime.leg2, true) }}
                    </div>
                  </div>
                  <i class="fas fa-car-side"></i>
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground3DO}]">
                    <span class="gt-r-loc-val" @click="wrap.ground3DO = !wrap.ground3DO">{{ locations.dropoffAirport.name }} ({{locations.dropoffAirport.code}})</span>
                    <div class="gt-r-value">
                      <span>Dropoff Time:</span>
                      {{ dateFormat(locations.pickupDetails.pickupTime.leg2, true, landQuote.leg2Depart.eta) }}
                      &middot;
                      {{ timeFormat(locations.pickupDetails.pickupTime.leg2, true, landQuote.leg2Depart.eta) }}
                    </div>
                  </div>
                </div>
                <label class="gt-skip">
                  <img src="../../assets/img/car-transport.svg" />
                  <input type="checkbox" v-model="ground2" @click="toggleGround(2)" />
                </label>
              </div>
              <div class="gt-action" @click="changeRide('leg2', 'pickup')">
                <span v-if="leg3Free" class="free-label">FREE</span>
                <div v-else>
                  <span v-if="leg3Discount.value > 0" class="free-label">{{ `${dcLabel(leg3Discount)} OFF` }}</span>

                  <div v-if="leg3Discount.value > 0" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg2', 'pickup'), false), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg2', 'pickup'), false))}}</span>
                  </div>
                  <div v-else-if="findById('leg2', 'pickup').price != findById('leg2', 'pickup').origPrice" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg2', 'pickup'), false, 'origPrice'), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg2', 'pickup'), false, 'origPrice'))}}</span>
                  </div>

                  <span v-if="currency.code === 'USD'" class="ground-price">{{priceFormat(fullPrice(findById('leg2', 'pickup'), 'Leg3'), true)}}</span>
                  <span v-else class="ground-price">{{applyCurrency(fullPrice(findById('leg2', 'pickup'), 'Leg3'))}}</span>
                </div>

                <img :src="findById('leg2', 'pickup').img" />
                <div class="gt-capacity d-flex justify-center">
                  <div>
                    <i class="far fa-user"></i>
                    {{ findById('leg2', 'pickup').maxPax }}
                  </div>
                  <div>
                    <i class="fas fa-suitcase"></i>
                    {{ findById('leg2', 'pickup').maxLuggage }}
                  </div>
                </div>
                <a>Change ride</a>
              </div>
            </div>

            <hr v-if="!hideGround.pickup && !hideGround.dropoff" />

            <div :class="['d-flex justify-space-between gt-ride', {'skip-ride':booking.includedLandTranspo.indexOf(3) === -1}]" v-if="!hideGround.pickup">
              <div class="gt-details">
                <div class="gt-r-service d-flex align-center">
                  <i class="fas fa-car-side"></i>
                  <div class="gt-r-status">Upcoming</div>
                  <span>{{ cabinLabel(findById('leg2', 'dropoff').name) }}</span>
                </div>
                <div class="gt-r-locations d-flex align-start">
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground4PU}]">
                    <span class="gt-r-loc-val" @click="wrap.ground4PU = !wrap.ground4PU">{{ locations.pickupAirport.name }} ({{locations.pickupAirport.code}})</span>
                    <div class="gt-r-value">
                      <span>Pickup Time:</span>
                      {{ dateFormat(locations.dropoffDetails.pickupTime.leg2, true) }}
                      &middot;
                      {{ timeFormat(locations.dropoffDetails.pickupTime.leg2, true) }}
                    </div>
                  </div>
                  <i class="fas fa-car-side"></i>
                  <div :class="['gt-r-box', {'gt-wrap':wrap.ground4DO}]">
                    <span class="gt-r-loc-val" @click="wrap.ground4DO = !wrap.ground4DO">{{ locations.pickup.title }}</span>
                    <div class="gt-r-value">
                      <span>Dropoff Time:</span>
                      {{ dateFormat(locations.dropoffDetails.pickupTime.leg2, true, landQuote.leg2Arrive.eta) }}
                      &middot;
                      {{ timeFormat(locations.dropoffDetails.pickupTime.leg2, true, landQuote.leg2Arrive.eta) }}
                    </div>
                  </div>
                </div>
                <label class="gt-skip">
                  <img src="../../assets/img/car-transport.svg" />
                  <input type="checkbox" v-model="ground3" @click="toggleGround(3)" />
                </label>
              </div>
              <div class="gt-action" @click="changeRide('leg2', 'dropoff')">
                <span v-if="leg4Free" class="free-label">FREE</span>
                <div v-else>
                  <span v-if="leg4Discount.value > 0" class="free-label">{{ `${dcLabel(leg4Discount)} OFF` }}</span>

                  <div v-if="leg4Discount.value > 0" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg2', 'dropoff'), false), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg2', 'dropoff'), false))}}</span>
                  </div>
                  <div v-else-if="findById('leg2', 'dropoff').price != findById('leg2', 'dropoff').origPrice" class="ground-price orig">
                    <span v-if="currency.code === 'USD'">{{priceFormat(fullPrice(findById('leg2', 'dropoff'), false, 'origPrice'), true)}}</span>
                    <span v-else >{{applyCurrency(fullPrice(findById('leg2', 'dropoff'), false, 'origPrice'))}}</span>
                  </div>

                  <span v-if="currency.code === 'USD'" class="ground-price">{{priceFormat(fullPrice(findById('leg2', 'dropoff'), 'Leg4'), true)}}</span>
                  <span v-else class="ground-price">{{applyCurrency(fullPrice(findById('leg2', 'dropoff'), 'Leg4'))}}</span>
                </div>

                <img :src="findById('leg2', 'dropoff').img" />
                <div class="gt-capacity d-flex justify-center">
                  <div>
                    <i class="far fa-user"></i>
                    {{ findById('leg2', 'dropoff').maxPax }}
                  </div>
                  <div>
                    <i class="fas fa-suitcase"></i>
                    {{ findById('leg2', 'dropoff').maxLuggage }}
                  </div>
                </div>
                <a>Change ride</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Seat Selection -->
        <!-- <div class="seat-bags-box it-page-box">
          <div class="sb-header">Seat Selection</div>
          <div class="sb-leg-info">
            <div class="sb-airport">
              {{ leg1Selected.flight[0].origin.AirportCode }}
              to
              {{ leg1Selected.flight[leg1Selected.flight.length - 1].destination.AirportCode }}
            </div>
            <div class="sb-desc">
              <i class="fas fa-ruler-combined"></i>
              <span>Seat choice for a fee</span>
            </div>
            <div class="sb-desc">
              <span>Purchase seats for this flight through China Airlines after booking.</span>
            </div>
          </div>
          <div class="sb-leg-info" v-if="isReturning">
            <div class="sb-airport">
              {{ leg2Selected.flight[0].origin.AirportCode }}
              to
              {{ leg2Selected.flight[leg2Selected.flight.length - 1].destination.AirportCode }}
            </div>
            <div class="sb-desc">
              <i class="fas fa-ruler-combined"></i>
              <span>Seat choice for a fee</span>
            </div>
            <div class="sb-desc">
              <span>Purchase seats for this flight through Korean Air after booking.</span>
            </div>
          </div>
        </div> -->

        <!-- Bags -->
         <!-- <div class="seat-bags-box it-page-box">
          <div class="sb-header">Bags</div>
          <div class="sb-leg-info">
            <div class="sb-airport">
              {{ leg1Selected.flight[0].origin.AirportCode }}
              to
              {{ leg1Selected.flight[leg1Selected.flight.length - 1].destination.AirportCode }}
            </div>
            <div class="sb-desc">
              <i class="fas fa-check"></i>
              <span>Carry-on bag included (15 lbs)</span>
            </div>
            <div class="sb-desc">
              <i class="fas fa-check"></i>
              <span>2 checked bags included (50 lbs each)</span>
            </div>
            <div class="sb-desc">
              <span>Additional bags for this flight must be purchased through the airline after booking.</span>
            </div>
          </div>
          <div class="sb-leg-info" v-if="isReturning">
            <div class="sb-airport">
              {{ leg2Selected.flight[0].origin.AirportCode }}
              to
              {{ leg2Selected.flight[leg2Selected.flight.length - 1].destination.AirportCode }}
            </div>
            <div class="sb-desc">
              <i class="fas fa-check"></i>
              <span>Carry-on bag included (15 lbs)</span>
            </div>
            <div class="sb-desc">
              <i class="fas fa-check"></i>
              <span>2 checked bags included (50 lbs each)</span>
            </div>
            <div class="sb-desc">
              <span>Additional bags for this flight must be purchased through the airline after booking.</span>
            </div>
          </div>
        </div> -->
      </div>
      <div class="it-body-summary">
        <payment-summary />
      </div>
    </div>

    <!-- Service Select-->
    <service-select :show="showService" :extraData="extraData" @close="showService = false" />

    <flight-details-modal ref="flightDetailsModal"/>
  </div>
</template>

<script>
const airportTimezone = require('airport-timezone')
import xcurrency from '@/modules/api/currency'
import flightDetailsBox from './FlightDetailsBox'
// import cabinDetailsBox from './CabinDetailsBox'
import serviceSelect from './ServiceSelect'
import FlightDetailsModal from './FlightDetailsModal'
import paymentSummary from '@/components/D2DOthers/PaymentSummary'
import moment from 'moment-timezone'

export default {
  name: 'itinerary',
  components: { flightDetailsBox, serviceSelect, paymentSummary, FlightDetailsModal },
  data () {
    return {
      ground0: true,
      ground1: true,
      ground2: true,
      ground3: true,
      showService: false,
      extraData: {leg: 'leg1', type: 'pickup'},
      wrap: {
        ground1PU: false,
        ground1DO: false,
        ground2PU: false,
        ground2DO: false,
        ground3PU: false,
        ground3DO: false,
        ground4PU: false,
        ground4DO: false
      }
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    locations () { return this.booking.locations },
    airlines () { return this.booking.airlines },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    selected () { return this.booking.selected },
    leg1Selected () { return this.selected.leg1 },
    leg2Selected () {
      if (!this.settings.customFlight) return this.selected.leg1
      return this.selected.leg2
    },
    landQuote () { return this.booking.landQuote },
    landQuoteType () { return this.booking.landQuoteType },
    user () { return this.$store.state.user },
    other () { return this.$store.state.other },
    currency () { return this.other.currency },
    _includedLandTranspo () { return this.booking.includedLandTranspo },
    hideGround () { return this.booking.hideGround },
    isSameAirline () {
      if (!this.isReturning) return
      if (!this.settings.customFlight) return true
      return this.leg1Selected.flightName.toLowerCase().replaceAll(' ', '') === this.leg2Selected.flightName.toLowerCase().replaceAll(' ', '')
    },
    settings () { return this.booking.settings },
    leg1Discount () { return this.settings.groundLeg1 },
    leg2Discount () { return this.settings.groundLeg2 },
    leg3Discount () { return this.settings.groundLeg3 },
    leg4Discount () { return this.settings.groundLeg4 },
    leg1Free () { return this.leg1Discount.free },
    leg2Free () { return this.leg2Discount.free },
    leg3Free () { return this.leg3Discount.free },
    leg4Free () { return this.leg4Discount.free }
  },
  methods: {
    groundBuild (type, leg) {
      let dateFormat = 'MMM DD - hh:mmA'
      let selected = this.booking.selected[leg]
      if (!this.settings.customFlight) selected = this.booking.selected.leg1

      let legType = `${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`
      let details = this.booking.landQuote[legType]
      let eta = details.eta
      let btt = Math.ceil(eta * 1.15)

      let isDomestic = false
      let flight = 'flight'
      if (leg === 'leg2' && !this.settings.customFlight) flight = 'returnFlight'
      let flightIndex = type === 'pickup' ? 0 : selected[flight].length - 1
      let originFlight = airportTimezone.find(x => x.code === selected[flight][flightIndex].origin.AirportCode)
      let destinationFlight = airportTimezone.find(x => x.code === selected[flight][flightIndex].destination.AirportCode)
      if (originFlight && destinationFlight && originFlight.countryCode === destinationFlight.countryCode) {
        isDomestic = true
      }

      let flightType = type === 'pickup' ? 'origin' : 'destination'
      let delay = parseFloat(this.settings[isDomestic ? 'departureBufferDomestic' : 'departureBufferInternational'])
      let date = moment(selected[flight][flightIndex][flightType].DateTime, 'YYYY-MM-DD HH:mm:ss')

      if (type !== 'pickup') {
        delay = parseFloat(this.settings[isDomestic ? 'arrivalBufferDomestic' : 'arrivalBufferInternational'])
        date.add(delay, 'minutes')
      } else {
        date.subtract(delay + btt, 'minutes')
      }

      let groundData = { pickupTime: date.format(dateFormat) }
      if (type === 'pickup') {
        groundData.pickup = this.locations[leg === 'leg1' ? 'pickup' : 'dropoff'].title
      } else {
        groundData.pickup = this.locations[leg === 'leg1' ? 'dropoffAirport' : 'dropoffAirportReturn'].name
      }

      this.$store.commit('booking/setLandPickupTime', {
        type: `${type}Details`,
        leg: leg,
        val: date.format('MM/DD/YYYY hh:mmA')
      })

      let tmpData = this.locations[type]
      tmpData.pickupTime = date.format('X')
      let tmpObj = {}
      tmpObj[type] = tmpData
      this.$store.commit('booking/setLocationsData', tmpObj)

      // if (type === 'pickup') {
      //   groundData.dropoff = this.locations[leg === 'leg1' ? 'pickupAirport' : 'pickupAirportReturn'].name
      //   date = moment(selected.flight[0].origin.DateTime, 'YYYY-MM-DD HH:mm:ss')
      //   groundData.dropoffTime = date.subtract(delay, 'minutes').format(dateFormat)
      // } else {
      //   groundData.dropoff = this.locations[leg === 'leg1' ? 'dropoff' : 'pickup'].title
      //   groundData.dropoffTime = date.add(btt, 'minutes').format(dateFormat)
      // }
      // return groundData
    },
    backLegSelect (leg) {
      let tmp = {}
      tmp[leg] = {}
      if (leg === 'leg1') tmp.leg2 = {}
      this.$store.commit('booking/setSelectedData', tmp)
      this.$store.commit('booking/setOthersData', {
        activeLeg: leg,
        servicesPage: 10
      })
      this.back()
    },
    back () {
      this.$store.commit('booking/setOthersData', {fetch: this.booking.cabinList})
      this.$router.push('d2dservice')
    },
    dateFormat (x, isFormated = false, eta = null) {
      if (!x) return ''
      let format = isFormated ? 'MM/DD/YYYY hh:mmA' : 'YYYY-MM-DD HH:mm'
      let date = moment(x, format)
      if (eta) date.add(eta, 'minutes')
      return date.format('ddd, MMM DD')
    },
    timeFormat (x, isFormated = false, eta = null) {
      if (!x) return ''
      let format = isFormated ? 'MM/DD/YYYY hh:mmA' : 'YYYY-MM-DD HH:mm'
      let date = moment(x, format)
      if (eta) date.add(eta, 'minutes')
      return date.format('h:mma')
    },
    timeDiff (x, y) {
      if (!x || !y) return ''
      x = moment(x, 'YYYY-MM-DD HH:mm')
      y = moment(y, 'YYYY-MM-DD HH:mm')
      let duration = moment.duration(y.diff(x))
      return `${duration._data.hours}h ${duration._data.minutes}m`
    },
    countStop (data) {
      if (data.length === 1) return 'Direct Flight'
      return `${data.length - 1} Stop${data.length > 2 ? 's' : ''}`
    },
    toggleGround (x) {
      let self = this
      self.$store.commit('booking/toggleIncludedLandTranspo', x)
      self.$nextTick(() => {
        if (window.gtag) { // eslint-disable-line
          let enable = self.booking.includedLandTranspo.indexOf(x) > -1 ? 'on' : 'off'
          gtag( // eslint-disable-line
            'event',
            'Taxi Check',
            {
              value: enable,
              ground: x + 1
            }
          )
        }
      })
    },
    changeRide (leg, type) {
      this.extraData = {
        leg: leg,
        type: type
      }
      this.showService = !this.showService
    },
    findById (leg, type) {
      // let categories = this.landQuote[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`].categorized
      let id = this.booking.selectedGround[leg][type]
      // for (const category in categories) {
      //   const foundItem = categories[category].find(item => item.id === selectedID)
      //   if (foundItem) return foundItem
      // }
      let landQuoteType = this.landQuoteType[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`]
      let landQuote = this.landQuote[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`]
      if (landQuoteType !== 'rsp') {
        let service = landQuote.list.find(x => x.id === id)
        if (service) return service
      } else {
        if (landQuote.Economy.id === id) return landQuote.Economy
        if (landQuote.PremiumEconomy.id === id) return landQuote.PremiumEconomy
        if (landQuote.Business.id === id) return landQuote.Business
        if (landQuote.First.id === id) return landQuote.First
        let service = landQuote.list.find(x => x.id === id)
        if (service) return service
      }

      return {
        name: '',
        img: '',
        maxPax: 1,
        maxLuggage: 1
      }
    },
    fullPrice (service, leg = 'Leg1', field = 'price') {
      if (!Object.keys(service).length || typeof service !== 'object') return 0
      let landFee = service[field]
      landFee += service.tip + service.pickupFee + service.airportFee + (service.gasFee || 0) + service.travelInsurance

      if (leg) {
        let groundLeg = this.settings[`ground${leg}`]
        if (groundLeg.value > 0) {
          if (groundLeg.currency === '$') {
            landFee -= groundLeg.value
          } else {
            let dc = landFee * (groundLeg.value / 100)
            landFee -= dc
          }
        }
      }
      if (parseFloat(landFee) < 0) landFee = 0
      return parseFloat(landFee.toFixed(2))
    },
    priceFormat (data, addSymbol = false) {
      let val = parseFloat(data).toLocaleString('en-US', {minimumFractionDigits: 2})
      if (addSymbol) {
        return data < 0 ? `-$ ${Math.abs(val).toFixed(2)}` : `$ ${parseFloat(val).toFixed(2)}`
      }
      return parseFloat(val).toFixed(2)
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    },
    isZero (x) {
      x = parseFloat(x)
      return x <= 0
    },
    dcLabel (x) {
      if (x.currency === '$') return `${x.currency}${x.value}`
      return `${x.value}${x.currency}`
    },
    showFlightDetails (leg) {
      if (this.$refs.flightDetailsModal) this.$refs.flightDetailsModal.showModal(leg)
    }
  },
  watch: {
    _includedLandTranspo (x) {
      this.ground0 = x.indexOf(0) > -1
      this.ground1 = x.indexOf(1) > -1
      this.ground2 = x.indexOf(2) > -1
      this.ground3 = x.indexOf(3) > -1
    }
  },
  created () {
    let flightLoc = this.locations.flight
    if (
      (!Object.keys(this.locations.pickupAirport).length && this.other.widgetTab === 'd2d') ||
      (!flightLoc.pickup.title && !flightLoc.pickup.name && this.other.widgetTab === 'flight')
    ) {
      this.$root.$router.push('search')
      return
    }
  },
  mounted () {
    document.querySelector('.itinerary-page').scrollIntoView()

    this.ground0 = this._includedLandTranspo.indexOf(0) > -1
    this.ground1 = this._includedLandTranspo.indexOf(1) > -1
    if (this.other.widgetTab === 'd2d') {
      this.groundBuild('pickup', 'leg1')
      this.groundBuild('dropoff', 'leg1')
    }
    if (this.isReturning) {
      this.ground2 = this._includedLandTranspo.indexOf(2) > -1
      this.ground3 = this._includedLandTranspo.indexOf(3) > -1
      if (this.other.widgetTab === 'd2d') {
        this.groundBuild('pickup', 'leg2')
        this.groundBuild('dropoff', 'leg2')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.itinerary-page{
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding-top: 20px;
}

.sh-nav{
  gap: 20px;
  color: #707f8f;
  margin-bottom: 30px;

  .default-txt{
    font-size: 18px;
    line-height: 50px;
  }
  .active{
    font-weight: 600;
    color: #333;
  }
  .sh-selected{
    gap: 10px;
    font-size: 18px;
    line-height: 50px;
    cursor: pointer;

    img{
      width: 50px;
    }
    .sh-airline{
      text-transform: capitalize;
    }
  }
  .change-flight{
    font-size: 13px;
    color: #3C8CE1!important;
    display: flex;
    line-height: 1;
    cursor: pointer;
  }
  .fa-chevron-right{
    line-height: 50px
  }
}
.back-to-home{
  margin-bottom: 10px;
  display: inline-block;
}

.it-page-header{
  color: #192024;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 15px;
  line-height: 1;
}

.it-page-body{
  gap: 20px;
  .it-page-box{
    border: 1px solid #abb2b8;
    border-radius: 6px;
    padding: 25px 20px;
    background: #fff;
  }
}
.it-body-details{
  width: calc(100% - 400px);
}
.expected-box{
  gap: 15px;
  line-height: 1;
  letter-spacing: .5px;
  background: #d8e2e9;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 15px;

  .fa-arrow-down{
    background: #227850;
    color: #fff;
    padding: 5px;
    border-radius: 100%;
  }
  b{
    font-size: 15px;
  }
  .fa-info-circle{
    margin-left: 2px;
  }
  .eb-desc{
    font-size: 13px;
    margin-top: 5px;
  }
}
.flight-details-box{
  margin-bottom: 30px;
  line-height: 1;

  .fd-header{
    margin-bottom: 20px;
    i{
      margin-right: 5px;
      transform: rotate(-45deg);
      color: #5f6d7c;
      vertical-align: 1px;
    }
    span{
      font-weight: 600;
      font-size: 21px;
      letter-spacing: .6px;
    }
  }
  .fd-trigger{
    color: #449ae7 !important;
    font-size: 13px;
    letter-spacing: .7px;
    font-weight: 600;
    margin-top: 20px;
    cursor: pointer;
  }
  .fd-hr{
    margin: 25px 0;
  }
}
.cabin-details{
  margin-bottom: 30px;

  .cd-title{
    font-size: 18px;
    font-weight: 600;
    letter-spacing: .6px;
  }
  .cd-sub{
    letter-spacing: .5px;
    font-size: 13px;
    color:#5E6E7F;
    margin-bottom: 15px;
  }
  .cd-box-container{
    gap: 20px;
  }
}
.ground-trans-box{
  margin-bottom: 30px;

  .gt-header, .gt-r-header{
    margin-bottom: 10px;
    line-height: 1;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: .5px;
  }
  .gt-box{
    margin-bottom: 15px;

    hr{
      margin: 25px 0;
      border: none;
      border-top: 1px solid #d1d3d5;
    }
  }
  .gt-ride{
    gap: 20px;

    &.skip-ride{
      .gt-r-service,
      .gt-r-locations,
      .gt-r-date,
      .gt-action{
        opacity: .5;
        filter: blur(.8px);
      }
    }
    .gt-r-service,
    .gt-r-locations,
    .gt-r-date,
    .gt-action{
      transition: all .3s ease;

      .free-label{
        background: #f14c4c;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        border-radius: 3px;
        display: table;
        margin: 0 auto 5px;
        padding: 4px 5px 2px;
        letter-spacing: .6px;
      }
    }
    .gt-capacity{
      gap: 20px;
      color: #5E6E7F;
      font-size: 14px;
      margin: 5px 0 10px;
      line-height: 1;

      i{
        margin-right: 5px;
      }
    }
  }
  .gt-details{
    width: calc(100% - 140px);
  }
  .gt-r-header{
    margin-bottom: 25px;
  }
  .gt-r-service{
    font-weight: 600;
    font-size: 21px;
    margin-bottom: 15px;

    i{
      margin-right: 10px;
      color: #717b87;
      font-size: 16px;
    }
    span{
      letter-spacing: .6px;
    }
  }
  .gt-r-locations{
    margin-bottom: 10px;
    gap: 15px;
    line-height: 1;

    .gt-r-box{
      max-width: calc((100% - 40px) / 2);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.gt-wrap{
        white-space: normal;
      }
    }
    .gt-r-loc-val{
      font-size: 18px;
      font-weight: 600;
      line-height: 1.4;
    }
    i{
      color: #717b87;
      line-height: 25px;
    }
  }
  .gt-r-value{
    letter-spacing: .5px;
    font-weight: 600;
    color: #5d748b;
    font-size: 15px;
    margin-top: 10px;
    white-space: normal;

    span{
      display: inline-block;
      margin-right: 3px;
    }
  }
  .gt-r-status{
    background: #ecae20;
    padding: 5px 10px;
    color: #fff;
    line-height: 1;
    border-radius: 12px;
    margin-right: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .gt-skip{
    line-height: 1;
    font-size: 13px;
    letter-spacing: .5px;
    cursor: pointer;

    img{
      width: 40px;
      margin-right: 10px;
    }
    input{
      margin-right: 8px;
      vertical-align: -2px;
    }
  }
  .gt-action{
    text-align: center;
    width: 150px;
    cursor: pointer;

    .ground-price{
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 5px;
      display: inline-block;

      &.orig{
        font-size: 15px;
        font-weight: 500;
        color: #aaa;
        text-decoration: line-through;
        margin: 0;
        display: block;
        text-decoration-color: red;
      }
    }
    a{
      line-height: 1;
      color:#3C8CE1!important;
      font-size: 13px;
    }
  }
}
.seat-bags-box{
  margin-bottom: 30px;
  .sb-header{
    font-size: 21px;
    line-height: 1;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .sb-leg-info{
    margin-bottom: 10px;
  }
  .sb-airport, .sb-desc{
    line-height: 1;
    letter-spacing: .5px;
  }
  .sb-airport{
    margin: 25px 0 10px;
    font-size: 18px;
    font-weight: 600;
  }
  .sb-desc{
    margin-bottom: 10px;
    color: #5E6E7F;
    font-size: 13px;

    i{
      margin-right: 7px;
    }
    span{
      letter-spacing: .5px;
    }
  }
}
.it-body-summary{
  width: 400px;
}


@media only screen and (max-width: 639px) {
  .sh-nav{
    overflow: auto;
    margin-bottom: 20px;
    white-space: nowrap;
    display: inline-block!important;
    width: 100%;
  }
  .sh-selected,
  .sh-nav .fa-chevron-right,
  .default-txt{
    display: inline-block!important;
  }
  .sh-selected{
    img,
    .sh-airline{
      margin-right: 5px;
    }
  }
  .sh-nav .fa-chevron-right{
    margin: 0 15px;
  }
  .it-page-body{
    flex-direction: column;
    gap: 0;
  }
  .it-body-details,
  .it-body-summary{
    width: 100%
  }
  .cd-box-container{
    overflow: auto;
    padding-bottom: 10px;
  }
  .cd-box{
    width: auto!important;
  }
  .cd-b-airport{
    font-size: 16px;
    white-space: nowrap;
  }
  .summary-box{
    margin-top: 0!important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1be694ee